import { TimeseriesDataPoint } from "../types";

export function sortByDate<T extends { date: string }>(data: T[]): T[] {
  return [...data].sort((a, b) =>
    new Date(a.date).getTime() - new Date(b.date).getTime()
  );
}

export const sortMetricsByDate = (metrics: TimeseriesDataPoint[]) => {
  return [...metrics].sort((a, b) =>
    new Date(a.date).getTime() - new Date(b.date).getTime()
  );
};
